import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5a300413"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title" }
const _hoisted_2 = { class: "generic-details-container" }
const _hoisted_3 = { class: "column" }
const _hoisted_4 = { class: "telephone-input-container" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "asteriskVisible" }, "Phone or Mobile Number", -1))
const _hoisted_6 = { class: "column" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Priority Services", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Electricity Suppliers maintain a 'Priority", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Services Register' for customers who are", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "critically dependent on electrical equipment", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "in their homes. Please indicate if this applies", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "at the property.", -1))

import AcquaintTextbox from "@/components/ui/inputs/acquaint-textbox.vue";
import { PropType, computed, ref } from "vue";
import { VueTelInput } from "vue-tel-input";
import LookupSingleSelect from "@/components/ui/lookup/lookup-single-select.vue";
import { PurchaserPersonalInfo } from "@/types/switches/PurchaserPersonalInfo";
import { ContactsValidation } from "acquaint-api/validation/ContactsValidation";
import { LookupTableSource } from "acquaint-api/constants/LookupTableSource";
import SwitchContactLookup from "@/components/ui/lookup/switch-contact-lookup.vue";
import { Contacts } from "acquaint-api/models/Contacts";
import { ContactFindTypeRestriction } from "@/enums/contacts/ContactFindTypeRestriction";
import SelectOption from "@/components/ui/inputs/select-option.vue";
import scrollView from "@/components/ui/scroll-view.vue";
import FieldValidationFreeDateBox from "../../ui/inputs/field-validation-free-date-box.vue";
import { FieldSize } from "@/enums/system/FieldSize";
import { TextboxValueChangeEvent } from "@/enums/ui/inputs/TextboxValueChangeEvent";


export default /*#__PURE__*/_defineComponent({
  __name: 'purchaser-details',
  props: {
  /**
   * The personal information of the purchaser.
   * @type {PurchaserPersonalInfo}
   * @required
   */
  purchaserDetails: {
    type: Object as PropType<PurchaserPersonalInfo>,
    required: true,
  },

  /**
   * Indicates whether the telephone number is valid.
   * @type {boolean}
   * @required
   */
  telephoneNumberValid: {
    type: Boolean,
    required: true,
  },

  /**
   * The title or heading associated with the component.
   * @type {string}
   * @default ''
   */
  title: {
    type: String,
    default: "",
  },

  /**
   * The validation group associated with the component, if applicable.
   * @type {string}
   * @default ''
   */
  validationGroup: {
    type: String,
    required: false,
    default: "",
  },
},
  emits: [
  "update:purchaserDetails",
  "update:telephoneNumberValid",
],
  setup(__props, { emit }) {

const props = __props;





const purchaserDetails = computed({
  get: () => props.purchaserDetails,
  set: (value: PurchaserPersonalInfo) => emit("update:purchaserDetails", value),
});

const preferredTelehoneNumbers = ["IE", "GB", "FR", "DE", "ES", "PL"];

const telehpneInputOptions = {
  required: true,
};

const telephoneNumberValid = computed({
  get: () =>
    props.telephoneNumberValid == undefined ||
    props.telephoneNumberValid == false
      ? false
      : true,
  set: (value: Boolean) =>
    emit(
      "update:telephoneNumberValid",
      value == undefined || value == false ? false : true,
    ),
});

const phoneNumberValidated = (e: any) => {
  telephoneNumberValid.value = e.valid;
};

const onContactSelected = async (e: Contacts) => {
  purchaserDetails.value.firstName = e.firstNames;
  purchaserDetails.value.lastName = e.lastName;
  purchaserDetails.value.title = e.titleID;
  purchaserDetails.value.email = e.email;
  purchaserDetails.value.number = e.mobileTelephone;
  purchaserDetails.value.id = e.id;
  purchaserDetails.value.birthDate = e.birthDate;
};

const lookupLabel = computed(() => {
  return `Look up ${props.title}`;
});

const tenantMaxBirthDate = new Date(
  new Date().setFullYear(new Date().getFullYear() - 18),
);

const onCriticalCareSelected = (selectedOption: number) =>
  (purchaserDetails.value.priorityService = selectedOption === 1);

const criticalCareToggleValue = computed(() =>
  purchaserDetails.value.priorityService ? 1 : 2,
);

const showPurchaserLookup = ref(false);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(scrollView, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(props.title) + " Details", 1),
      _createElementVNode("section", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (showPurchaserLookup.value)
            ? (_openBlock(), _createBlock(SwitchContactLookup, {
                key: 0,
                "find-type-restriction": _unref(ContactFindTypeRestriction).Purchasers,
                label: lookupLabel.value,
                onContactSelected: onContactSelected,
                toolTipId: "purchaseDetails",
                toolTipTarget: "#purchaseDetails"
              }, {
                "tooltip-content": _withCtx(() => [
                  _createTextVNode("Search for an existing contact to pre-fill the information below.")
                ]),
                _: 1
              }, 8, ["find-type-restriction", "label"]))
            : _createCommentVNode("", true),
          _createVNode(LookupSingleSelect, {
            modelValue: purchaserDetails.value.title,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((purchaserDetails.value.title) = $event)),
            "lookup-source": _unref(LookupTableSource).Titles,
            requiredInput: false,
            validationGroup: props.validationGroup,
            label: "Title",
            "allow-zero-value": true
          }, null, 8, ["modelValue", "lookup-source", "validationGroup"]),
          _createVNode(AcquaintTextbox, {
            modelValue: purchaserDetails.value.firstName,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((purchaserDetails.value.firstName) = $event)),
            fieldValidation: _unref(ContactsValidation).FirstNames,
            label: "First Name",
            requiredInput: true,
            validationGroup: props.validationGroup,
            "value-change-event": _unref(TextboxValueChangeEvent).Change
          }, null, 8, ["modelValue", "fieldValidation", "validationGroup", "value-change-event"]),
          _createVNode(AcquaintTextbox, {
            modelValue: purchaserDetails.value.lastName,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((purchaserDetails.value.lastName) = $event)),
            fieldValidation: _unref(ContactsValidation).LastName,
            label: "Last Name",
            requiredInput: true,
            validationGroup: props.validationGroup,
            "value-change-event": _unref(TextboxValueChangeEvent).Change
          }, null, 8, ["modelValue", "fieldValidation", "validationGroup", "value-change-event"]),
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_unref(VueTelInput), {
              defaultCountry: 353,
              inputOptions: telehpneInputOptions,
              modelValue: purchaserDetails.value.number,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((purchaserDetails.value.number) = $event)),
              mode: "international",
              "valid-characters-only": true,
              onValidate: phoneNumberValidated,
              preferredCountries: preferredTelehoneNumbers
            }, null, 8, ["modelValue"])
          ]),
          _createVNode(AcquaintTextbox, {
            modelValue: purchaserDetails.value.email,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((purchaserDetails.value.email) = $event)),
            fieldValidation: _unref(ContactsValidation).Email,
            label: "Email",
            validationGroup: props.validationGroup,
            requiredInput: true,
            "value-change-event": _unref(TextboxValueChangeEvent).Change
          }, null, 8, ["modelValue", "fieldValidation", "validationGroup", "value-change-event"]),
          _createVNode(FieldValidationFreeDateBox, {
            label: "Date of Birth",
            fieldValidation: _unref(ContactsValidation).BirthDate,
            modelValue: purchaserDetails.value.birthDate,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((purchaserDetails.value.birthDate) = $event)),
            required: true,
            maxDate: _unref(tenantMaxBirthDate),
            width: _unref(FieldSize).Small,
            validationGroup: props.validationGroup
          }, null, 8, ["fieldValidation", "modelValue", "maxDate", "width", "validationGroup"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(SelectOption, {
            useToolTip: true,
            toolTipId: "priorityServices",
            toolTipTarget: "#priorityServices",
            title: "Priority Services (Critical Care)",
            selectBoxOneText: "Yes",
            selectBoxTwoText: "No",
            value: criticalCareToggleValue.value,
            onButtonSelected: onCriticalCareSelected,
            width: "180px"
          }, {
            "tooltip-content": _withCtx(() => [
              _hoisted_7,
              _hoisted_8,
              _hoisted_9,
              _hoisted_10,
              _hoisted_11,
              _hoisted_12,
              _hoisted_13,
              _hoisted_14,
              _hoisted_15,
              _hoisted_16,
              _hoisted_17
            ]),
            _: 1
          }, 8, ["value"])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})